import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutLogout32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowOutLogout32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 10a4 4 0 0 1 4-4h7a1 1 0 1 1 0 2h-7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a1 1 0 1 1 0 2h-7a4 4 0 0 1-4-4zm7 6a1 1 0 0 1 1-1h8.086l-1.793-1.793a1 1 0 0 1 1.414-1.414l3.536 3.535.707.707-.707.708-3.536 3.535a1 1 0 0 1-1.414-1.414L22.157 17H14a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutLogout32);
